///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-core-locations.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportCoreLocationsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected locations: ReportCoreLocationsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.locations;
        }

        constructor(model: Dictionary<any>, properties: string[], { criteria }) {
            super(model, properties, criteria);

            this.locations = new ReportCoreLocationsCollection(this.model[properties[0]], [], {
                criteria,
                displayNameKey: 'storeName'
            });

            this.title = 'LABEL_LOCATION';
            this.allSelectedLabel = 'LABEL_ALL_LOCATIONS';
            this.totalSelectedMessage = 'LABEL_TOTAL_LOCATIONS_SELECTED';
        }
    }
}
